import  * as api from  '@/api/kzActivity/kzActivity'
import * as TYPES from './type';

//签到
import signActions from './sign/actions'

//表现
import showActions from './show/actions'

//讨论
import discussActions from './discuss/actions'

//问卷
import quesActions from './ques/actions'

//互评
import mutualEvaluateActions from './mutualEvaluate/actions'

//互评
import testActions from './test/actions'

export default {
  // 课中活动
  async getjxCourseList({ commit, state }, cb) {
    const result = await api.reqjxCourseList()
    commit(TYPES.ACTIVITY_LIST_INFO, { result, type: 'courseList' })
    cb && cb()
  },
  ...signActions, //签到
  ...showActions, //表现
  ...discussActions, //讨论
  ...quesActions, //问卷
  ...mutualEvaluateActions, //互评
  ...testActions, //测验
}